import { Instagram, Facebook, Linkedin } from "lucide-react";
import { SOCIAL_LINKS } from "../lib/siteConfig";

const svg = (d) => ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true"><path d={d} /></svg>
);

export const TikTokIcon = svg("M16.6 5.82A4.28 4.28 0 0 1 15.54 3h-3.09v12.4a2.59 2.59 0 0 1-2.59 2.5 2.6 2.6 0 0 1-2.6-2.6 2.6 2.6 0 0 1 3.37-2.48V9.66a5.68 5.68 0 0 0-.77-.05A5.73 5.73 0 0 0 4.13 15.3 5.73 5.73 0 0 0 9.86 21a5.73 5.73 0 0 0 5.73-5.7V9.01a7.35 7.35 0 0 0 4.28 1.37V7.3a4.28 4.28 0 0 1-3.27-1.48z");
export const XIcon = svg("M17.75 3h3.07l-6.7 7.66L22 21h-6.17l-4.83-6.32L5.47 21H2.4l7.17-8.2L2 3h6.33l4.37 5.77L17.75 3zm-1.08 16.17h1.7L7.4 4.74H5.58l11.09 14.43z");
const Google = svg("M21.35 11.1H12v2.98h5.38c-.24 1.38-1.62 4.04-5.38 4.04-3.24 0-5.88-2.68-5.88-5.99s2.64-5.99 5.88-5.99c1.84 0 3.08.79 3.78 1.46l2.58-2.48C16.71 3.6 14.57 2.6 12 2.6 6.82 2.6 2.62 6.8 2.62 12s4.2 9.4 9.38 9.4c5.41 0 9-3.8 9-9.16 0-.62-.07-1.09-.15-1.14z");

const ICONS = { instagram: Instagram, facebook: Facebook, linkedin: Linkedin, tiktok: TikTokIcon, x: XIcon, google: Google };

export const SocialLinks = ({ className = "", iconClass = "h-5 w-5", testIdPrefix = "social" }) => (
  <div className={`flex items-center gap-4 ${className}`}>
    {SOCIAL_LINKS.map(({ network, label, url }) => {
      const Icon = ICONS[network];
      return (
        <a
          key={network}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={label}
          title={label}
          className="text-zinc-500 hover:text-orange-500 transition-colors"
          data-testid={`${testIdPrefix}-${network}`}
        >
          <Icon className={iconClass} />
        </a>
      );
    })}
  </div>
);
